import user from "@/client/api/user";

const state = {
  name: null,
  email: null,
};
const getters = {};
const actions = {
  async getMyInfo({ commit }) {
    let res = await user.getMyInfo();
    if (res.data && res.data.data) {
      let data = res.data.data;
      commit("setName", data.name);
      commit("setEmail", data.email);
    }
  },
};
const mutations = {
  setName(state, value) {
    state.name = value;
  },
  setEmail(state, value) {
    state.email = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
